
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.UnplannedStop = {

  template: () => {
      return {
          tag: 'div',
          items: [
              {
                  items: [
                      {
                          tag: 'label',
                          items: [
                              {
                                  tag: 'span',
                                  html: Monet.I18n.getResourcesByKey('event.check.unplanned.timeMinutes'),
                                  attributes: {
                                      'class': 'i18nResource',
                                  },
                              },
                          ],
                          attributes: {
                              class: 'control-label',
                              for: 'unplanned_stop_time_minutes',
                          },
                      },
                      {
                          items: [
                              {
                                  tag: 'input',
                                  attributes: {
                                      'type': 'text',
                                      name: 'unplanned_stop_time_minutes',
                                      'maxlength': '4',
                                      alt: '',
                                      'value': '',
                                      size: '11',
                                      'id': 'unplanned_stop_time_minutes',
                                      class: 'modelAttribute textField numberPicker mandatory',
                                      autocomplete: 'off',
                                  },
                              },
                              {
                                  tag: 'input',
                                  attributes: {
                                      type: 'checkbox',
                                      id: 'hos_check',
                                      'class': 'modelAttribute checkbox',
                                      'style': 'margin-left: 30px'
                                  },
                              },
                              {
                                  tag: 'span',
                                  html: Monet.I18n.getResourcesByKey('event.check.unplannedStop.hosCheck'),
                                  attributes: {
                                    'style': 'margin-left: 5px'
                                  }
                              }
                          ],
                          attributes: {
                              class: 'controls',
                          },
                      },
                      {
                          items: [
                              {
                                  tag: 'label',
                                  items: [
                                      {
                                          tag: 'span',
                                          html: Monet.I18n.getResourcesByKey('event.check.unaplannedStop.hosTypes'),
                                          attributes: {
                                              class: 'i18nResource',
                                              id: 'span-hosTypes',
                                              style: 'display: none'
                                          },
                                      },
                                  ],
                                  attributes: {
                                      class: 'control-label',
                                      for: 'hosTypes',
                                  },
                              },
                              {
                                  items: [
                                      {
                                          tag: 'select',
                                          attributes: {
                                              multiple: 'true',
                                              id: 'hosTypes',
                                              style: 'display: none',
                                              required: true
                                          },
                                      },
                                  ],
                                  attributes: {
                                      class: 'controls',
                                  },
                              },
                          ],
                          attributes: {
                              class: 'control-group',
                              style: 'margin-top: 10px'
                          },
                      },
                  ],
              }
          ]
      };
  },

  assignParameter: (jsonParam) => {
    let hosTypes = [
      Monet.I18n.getResourcesByKey('event.check.unplannedStop.hosType.startBreak'),
      Monet.I18n.getResourcesByKey('event.check.unplannedStop.hosType.endBreak'),
      Monet.I18n.getResourcesByKey('event.check.unplannedStop.hosType.startLunch'),
      Monet.I18n.getResourcesByKey('event.check.unplannedStop.hosType.endLunch'),
    ];

    let hosTypesEnum = [ "BREAK_START", "BREAK_END", "LUNCH_START", "LUNCH_END"];

    let isSelected, hosTypesSelected;

    const checkbox = document.querySelector('#hos_check');
    const select = document.querySelector('#hosTypes');
    const span = document.querySelector('#span-hosTypes');

    if (jsonParam) {
      const timeMinutes = document.getElementById('unplanned_stop_time_minutes');
      jsonParam = JSON.parse(jsonParam);

      timeMinutes.value = jsonParam.timeMinutes;
      hosTypesSelected = jsonParam.hosTypes;
      checkbox.checked = jsonParam.hosChecked;

      if(checkbox.checked) {
        select.style.display = 'block';
        span.style.display = 'block';
      } else {
        select.style.display = 'none';
        span.style.display = 'none';
      }

      for (let x = 0; x < hosTypesEnum.length; x++) {
        if(hosTypesSelected) {
          isSelected = hosTypesSelected.filter((item) => { return item === hosTypesEnum[x]}).length > 0;
          $('#hosTypes').append(new Option(hosTypes[x], hosTypesEnum[x], false, isSelected));
          isSelected = false;
        } else {
          $('#hosTypes').append(new Option(hosTypes[x], hosTypesEnum[x], false, false));
        }
      }

    } else {
        for (let x = 0; x < hosTypesEnum.length; x++) {
            $('#hosTypes').append(new Option(hosTypes[x], hosTypesEnum[x], false, false));
        }
    }

    checkbox.addEventListener('click', (event) => {
       if(event.target.checked) {
         select.style.display = 'block';
         span.style.display = 'block';
       } else {
         select.style.display = 'none';
         span.style.display = 'none';

         let hosTypes = $('#hosTypes option');

         for(let i = 0; i < hosTypes.length; i++) {
             hosTypes[i].selected = false;
         }
       }
    });
  },

  retrieveParameter: () => {
    const unplanned_stop_time_minutes = document.getElementById('unplanned_stop_time_minutes');
    const timeMinutes = unplanned_stop_time_minutes && unplanned_stop_time_minutes.value;

    const unplanned_stop_hos_check = document.querySelector('#hos_check');
    const checkbox = unplanned_stop_hos_check && unplanned_stop_hos_check.checked;

    const hosTypesSelected = [];
    const hosTypesSize = $('#hosTypes option:selected').length;
    let c = 0;

    for (let x = 0; x < hosTypesSize; x++) {
      const value = $('#hosTypes option:selected')[x].value;

      if (value !== null) {
          hosTypesSelected[c] = value;
          c++;
      }
    }

    return JSON.stringify({
      timeMinutes: timeMinutes,
      hosChecked: checkbox,
      hosTypes: hosTypesSelected
    });
  }
};
